import React from "react";
import { Skeleton } from "../PainelShimmerChrome";
import "./MobileSolutionsSkeleton.scss";

const ROW_COUNT = 6;

interface MobileSolutionsSkeletonProps {
  isDarkMode?: boolean;
}

const MobileSolutionsSkeleton: React.FC<MobileSolutionsSkeletonProps> = ({
  isDarkMode = false,
}) => (
  <div
    className={`mobile-solutions-skeleton${isDarkMode ? " mobile-solutions-skeleton--dark" : ""}`}
    aria-busy="true"
    aria-label="Carregando soluções"
  >
    {Array.from({ length: ROW_COUNT }, (_, index) => (
      <div
        key={index}
        className={`mobile-solutions-skeleton__card${index % 2 ? " is-zebra" : ""}`}
      >
        <div className="mobile-solutions-skeleton__header">
          <div className="mobile-solutions-skeleton__identity">
            <Skeleton height={15} width={150} />
            <Skeleton height={12} width={190} />
            <Skeleton height={12} width={130} />
          </div>
          <div className="mobile-solutions-skeleton__actions">
            <Skeleton height={36} width={36} borderRadius="50%" />
            <Skeleton height={36} width={36} borderRadius="50%" />
          </div>
        </div>
        <Skeleton height={32} width="80%" borderRadius={4} />
      </div>
    ))}
  </div>
);

export default MobileSolutionsSkeleton;
